/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAdvertisers} from '../api'

 export const useQueryGetAdvertisers = createReactQueryHook('getAdvertisers', getAdvertisers)
